/**
 * All time display helpers — force Asia/Kolkata (IST) regardless of
 * where the browser or Vercel server is running.
 */

const IST = 'Asia/Kolkata';

/** "28 Mar 2026, 09:45 PM" */
export function formatIST(dateStr) {
  return new Date(dateStr).toLocaleString('en-IN', {
    timeZone: IST,
    day:      '2-digit',
    month:    'short',
    year:     'numeric',
    hour:     '2-digit',
    minute:   '2-digit',
    hour12:   true,
  });
}

/** "28 Mar, 09:45 PM"  (no year — for compact table cells) */
export function formatISTShort(dateStr) {
  return new Date(dateStr).toLocaleString('en-IN', {
    timeZone: IST,
    day:      '2-digit',
    month:    'short',
    hour:     '2-digit',
    minute:   '2-digit',
    hour12:   true,
  });
}

/** "09:45 PM"  (time only) */
export function formatISTTime(dateStr) {
  return new Date(dateStr).toLocaleString('en-IN', {
    timeZone: IST,
    hour:     '2-digit',
    minute:   '2-digit',
    hour12:   true,
  });
}

/** "2026-03-28"  — for date-picker default values in IST */
export function todayIST() {
  return new Date().toLocaleDateString('en-CA', { timeZone: IST }); // en-CA gives YYYY-MM-DD
}
